import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const splitLink = async (id, data) => {
  const response = await axios.post(
    routes.inviteflowSplit(id),
    data,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default splitLink;
